<template>
  <el-main>
    <div class="formSubmitBtnBox">
      <el-button type="primary" @click="dialogVisible = !dialogVisible" align="right">{{
        dialogVisible ? "完成" : "修改"
      }}</el-button>
    </div>
    <div  align="center" style="color:red">由於客戶需求，目前前台只顯示次選項，但主選項仍依然必要，故建議使用正確主選項名稱。</div>
    <el-row v-if="!dialogVisible">
      <el-col :span="12" :offset="6">
        <div class="block-div" v-for="(el, mainIndex) in examLocation" :key="mainIndex">
          <el-row>
            <el-col :span="24">
              <el-radio disabled v-model="el.mainLocation" label="禁用">{{
                el.mainLocation
              }}</el-radio>
            </el-col>
          </el-row>
          <br />
          <el-row v-for="sb in el.subExamLocation" :key="sb.id">
            <el-col :span="12" :offset="4" style="margin:8px 8px">
              <el-radio disabled v-model="sb.subLocation" label="禁用">{{
                sb.subLocation
              }}</el-radio>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- ------------------------------------------------------------------------------------------------------ -->
    <el-row v-if="dialogVisible">
      <el-col :span="12" :offset="6">
        <div class="block-div" v-for="(el, mainIndex) in examLocation" :key="mainIndex">
          <el-row>
            <el-col :span="6" style="padding:16px 0">選項群組：</el-col>
            <el-col :span="15"
              ><el-input
                style="margin:8px 0px;"
                v-model="el.mainLocation"
                maxlength="20"
                show-word-limit
                @blur="updateMian(el.id, el.mainLocation)"
              ></el-input
            ></el-col>
            <el-col :span="1" style="margin:8px 8px"
              ><el-button type="danger" plain @click="deleteMainOption(el.id)"
                ><i class="el-icon-delete-solid"></i></el-button
            ></el-col>
          </el-row>
          <br />
          <el-row v-for="(sb, subIndex) in el.subExamLocation" :key="sb.id">
            <el-col :span="5" :offset="2" style="padding:16px 0">選項 {{ subIndex + 1 }}：</el-col>
            <el-col :span="11" style="margin:8px 8px"
              ><el-input
                v-model="sb.subLocation"
                maxlength="10"
                show-word-limit
                @blur="updateSub(sb.id, sb.subLocation, el.id)"
              ></el-input
            ></el-col>
            <el-col :span="4" style="margin:8px 0"
              ><el-button type="danger" plain @click="deleteOption(sb.id, mainIndex, subIndex)"
                ><i class="el-icon-delete-solid"></i
              ></el-button>
            </el-col>
          </el-row>
          <el-col :offset="1">
            選項 ：
            <el-button style="margin:8px 18px" type="success" plain @click="addOption(mainIndex)">
              <i class="el-icon-plus"></i
            ></el-button>
          </el-col>
        </div>

        <div class="block-div">
          <el-button style="margin:8px 0px;" type="success" plain @click="addMainOption()">
            <i class="el-icon-plus"></i>選項群組</el-button
          >
        </div>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
import {
  C_ExamMainLocation_GetList,
  C_ExamMainLocation_Delete,
  C_ExamMainLocation_Update,
  C_ExamSubLocation_Delete,
  C_ExamSubLocation_Update,
} from '@/assets/js/api';

export default {
  data() {
    return {
      examLocation: [],
      dialogVisible: false,
      addMainLocation: {
        mainLocation: '',
      },
    };
  },
  methods: {
    updateSub(subId, subLocation, mainId) {
      const subModel = { id: subId, subLocation, MainLocationId: mainId };
      C_ExamSubLocation_Update(subModel)
        .then((res) => {
          this.$message({
            type: res.data.message === '400' ? 'error' : 'success',
            message: res.data.message === '400' ? '請先輸入選項群組' : res.data.message,
          });
          this.GetExamLocations();
        })
        .catch((err) => {
          this.$message({
            type: 'info',
            message: err.response.data.message,
          });
        });
    },
    updateMian(mId, mLocation) {
      const model = { id: mId, MainLocation: mLocation };
      C_ExamMainLocation_Update(model)
        .then((res) => {
          this.$message({
            type: 'success',
            message: res.data.message,
          });
          this.GetExamLocations();
        })
        .catch((err) => {
          this.$message({
            type: 'info',
            message: err.response.data.message,
          });
        });
    },
    GetExamLocations() {
      C_ExamMainLocation_GetList()
        .then((res) => {
          this.examLocation = res.data.data;
          console.log(this.examLocation);
        })
        .catch((err) => console.log(err));
    },
    addMainOption() {
      this.examLocation.push({ mainLocation: '', subExamLocation: [] });
    },
    addOption(mainIndex) {
      this.examLocation[mainIndex].subExamLocation.push({
        mainLocationId: this.examLocation[mainIndex].id,
        subLocation: '',
      });
    },
    deleteOption(sId, mainIndex, subIndex) {
      if (sId === undefined) {
        this.examLocation[mainIndex].subExamLocation.splice(subIndex, 1);
        return;
      }
      this.$confirm('請問是否確定刪除?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_ExamSubLocation_Delete(sId)
            .then((res) => {
              this.$notify({
                title: '成功',
                message: res.data.message,
                type: 'success',
              });
              this.GetExamLocations();
            })
            .catch((err) => {
              this.$notify.error({
                title: '錯誤',
                message: err.response.data.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消刪除',
          });
        });
    },
    deleteMainOption(mainId) {
      this.$confirm('請問是否確定刪除?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_ExamMainLocation_Delete(mainId)
            .then((res) => {
              this.$notify({
                title: '成功',
                message: res.data.message,
                type: 'success',
              });
              this.GetExamLocations();
            })
            .catch((err) => {
              this.$notify.error({
                title: '錯誤',
                message: err.response.data.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消刪除',
          });
        });
    },
  },
  computed: {},
  mounted() {
    C_ExamMainLocation_GetList()
      .then((res) => {
        this.examLocation = res.data.data;
        console.log(this.examLocation);
      })
      .catch((err) => console.log(err));
  },
};
</script>

<style scoped>
.block-div {
  /* Auto Layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #0089fa10;

  position: static;

  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 16px 0px;
}
</style>
